import { AlertDrilldown } from '@sprinklr/stories/post/AlertDrilldown';
import { AnalyticsRequest } from '@sprinklr/stories/analytics/AnalyticsRequest';

export type AlertDrilldownConfig = Pick<
    AnalyticsRequest,
    'groupBys' | 'projections' | 'projectionDecorations' | 'includeTotal' | 'sorts' | 'limit'
>;

export const alertDrilldownConfig: Record<keyof AlertDrilldown, AlertDrilldownConfig> = {
    mentions: {
        groupBys: [],
        projections: [
            {
                heading: 'MENTIONS_COUNT_248',
                measurementName: 'MENTIONS_COUNT',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Mentions',
                },
            },
        ],
        projectionDecorations: ['PERCENTAGE_CHANGE', 'CHANGE'],
    },
    volumeTrend: {
        groupBys: [
            {
                heading: 'DATE_VOLUME_TREND',
                dimensionName: 'SN_CREATED_TIME',
                groupType: 'DATE_HISTOGRAM',
                details: {
                    alternateHeading: 'Created Time',
                    interval: '1h',
                },
            },
        ],
        projections: [
            {
                heading: 'MENTIONS_COUNT_248',
                measurementName: 'MENTIONS_COUNT',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Mentions',
                },
            },
            {
                heading: 'POS_SEN_249',
                measurementName: 'POS_SEN',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Positive Mentions',
                },
            },
            {
                heading: 'NEG_SEN_250',
                measurementName: 'NEG_SEN',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Negative Mentions',
                },
            },
        ],
    },
    sentiment: {
        groupBys: [
            {
                heading: 'SEM_SENTIMENT',
                dimensionName: 'SEM_SENTIMENT',
                groupType: 'FIELD',
                details: {
                    alternateHeading: 'Sentiment',
                },
            },
        ],
        projections: [
            {
                heading: 'MENTIONS_COUNT',
                measurementName: 'MENTIONS_COUNT',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Mentions',
                },
            },
        ],
        includeTotal: true,
        sorts: [
            {
                heading: 'MENTIONS_COUNT',
                order: 'DESC',
            },
        ],
        limit: 50,
    },
    // topicCluster: {
    //     groupBys: [
    //         {
    //             heading: 'TOPIC_CLUSTER_0',
    //             dimensionName: 'TOPIC_CLUSTER',
    //             groupType: 'FIELD',
    //         },
    //     ],
    //     projections: [
    //         {
    //             heading: 'MENTIONS_COUNT',
    //             measurementName: 'MENTIONS_COUNT',
    //             aggregateFunction: 'SUM',
    //             details: {
    //                 alternateHeading: 'Mentions',
    //             },
    //         },
    //     ],
    //     limit: 6,
    // },
    topWords: {
        groupBys: [
            {
                heading: 'TOP_TERMS',
                dimensionName: 'WORD_CLOUD_MESSAGE',
                groupType: 'FIELD',
                details: {},
            },
        ],
        projections: [
            {
                heading: 'MENTIONS_COUNT',
                measurementName: 'MENTIONS_COUNT',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Mentions',
                },
            },
        ],
        sorts: [
            {
                heading: 'MENTIONS_COUNT',
                order: 'DESC',
            },
        ],
        limit: 50,
    },
    topHashtags: {
        groupBys: [
            {
                heading: 'HASHTAGS',
                dimensionName: 'HASHTAGS',
                groupType: 'FIELD',
            },
        ],
        projections: [
            {
                heading: 'MENTIONS_COUNT',
                measurementName: 'MENTIONS_COUNT',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Mentions',
                },
            },
        ],
        sorts: [
            {
                heading: 'MENTIONS_COUNT',
                order: 'DESC',
            },
        ],
        limit: 10,
    },
    topLanguages: {
        groupBys: [
            {
                heading: 'lng',
                dimensionName: 'LST_SUPP_LNG',
                groupType: 'FIELD',
                limitType: 'TOP',
                limit: 10,
            },
            {
                heading: 'SENTIMENT',
                dimensionName: 'SEM_SENTIMENT',
                groupType: 'FIELD',
            },
        ],
        projections: [
            {
                heading: 'MENTIONS_COUNT',
                measurementName: 'MENTIONS_COUNT',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Mentions',
                },
            },
        ],
        sorts: [
            {
                heading: 'MENTIONS_COUNT',
                order: 'DESC',
            },
        ],
    },
    topCountries: {
        groupBys: [
            {
                heading: 'COUNTRY',
                dimensionName: 'COUNTRY',
                groupType: 'FIELD',
                limitType: 'TOP',
                limit: 10,
            },
            {
                heading: 'SENTIMENT',
                dimensionName: 'SEM_SENTIMENT',
                groupType: 'FIELD',
            },
        ],
        projections: [
            {
                heading: 'MENTIONS_COUNT',
                measurementName: 'MENTIONS_COUNT',
                aggregateFunction: 'SUM',
                details: {
                    alternateHeading: 'Mentions',
                },
            },
        ],
        sorts: [
            {
                heading: 'MENTIONS_COUNT',
                order: 'DESC',
            },
        ],
    },
};
